import React, { useEffect } from "react";
import { notification } from "antd";
import moment from "moment";
import DataParser from "../../utlits/Dataparser";
import CrmLeadsServices from "../../Services/CrmLeadsServices";
import { useNavigate } from "react-router-dom";

const GlobalLeadNotifier = () => {
    const userId = DataParser.UserId();
    const companyId = DataParser.CompanyId();
    const navigate = useNavigate();
    const companyIdentifier = DataParser.CompanyIdentifier();

    useEffect(() => {
        const checkReminders = async () => {
            if (!userId || !companyId) return;

            const today = moment().format("YYYY-MM-DD");
            const storageKey = `crm_global_notified_${userId}_${today}`;

            // 1. Skip if already notified today
            if (localStorage.getItem(storageKey)) return;

            try {
                // 2. Fetch leads for today's follow-ups only (V2)
                const filters = {
                    tab: 'due_today',
                    ownerFilter: userId
                };
                const res = await CrmLeadsServices.getPaginatedLeads(companyId, 1, 50, filters);
                
                if (res.Good && res.data) {
                    const todayLeads = res.data;
                    
                    // 3. (Filtering already done on server)

                    // 4. Show individual or summary notifications
                    if (todayLeads.length > 0) {
                        if (todayLeads.length <= 3) {
                            // Show individual notifications for few leads
                            todayLeads.forEach(lead => {
                                notification.info({
                                    message: "Lead Follow Up Reminder",
                                    description: `Scheduled for: ${lead.title}`,
                                    placement: "topRight",
                                    duration: 10,
                                    onClick: () => {
                                        navigate(`/${companyIdentifier}/crm-leads`, {
                                            state: { LeadId: lead.id }
                                        });
                                    },
                                    icon: <i className="uil uil-bell font-size-18" style={{ color: "#0DDFAB" }} />,
                                    style: { borderRadius: '8px', cursor: 'pointer' }
                                });
                            });
                        } else {
                            // Show summary notification for many leads
                            notification.info({
                                message: "Lead Follow Up Reminder",
                                description: `Hello! You have ${todayLeads.length} leads scheduled for follow-up today.`,
                                onClick: () => {
                                    navigate(`/${companyIdentifier}/crm-leads`);
                                },
                                placement: "topRight",
                                duration: 8,
                                icon: <i className="uil uil-bell font-size-18" style={{ color: "#0DDFAB" }} />,
                                style: { borderRadius: '8px', cursor: 'pointer' }
                            });
                        }
                        
                        // 5. Mark as notified
                        localStorage.setItem(storageKey, "true");
                    }
                }
            } catch (err) {
                console.error("Global lead reminder check failed:", err);
            }
        };

        // Delay the check slightly to allow the app to settle
        const timer = setTimeout(checkReminders, 2000);
        return () => clearTimeout(timer);
    }, [userId, companyId]);

    return null; // This component doesn't render any UI itself
};

export default GlobalLeadNotifier;
